import styled from 'styled-components';

export const PaymentStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  max-width: 600px;
  margin: 2rem auto;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const StatusIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 2.5rem;

  ${({ status }) => {
    switch (status) {
      case 'success':
        return `
          background-color: #e6f7ed;
          color: #52c41a;
        `;
      case 'error':
        return `
          background-color: #fff2f0;
          color: #ff4d4f;
        `;
      case 'processing':
        return `
          background-color: #e6f7ff;
          color: #1890ff;
        `;
      default:
        return '';
    }
  }}
`;

export const StatusTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #262626;
`;

export const StatusMessage = styled.p`
  font-size: 1rem;
  color: #595959;
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

export const ErrorDetails = styled.div`
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  padding: 1rem;
  margin-top: 1rem;
  width: 100%;
`;

export const ActionButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  background-color: #1890ff;
  color: white;
  transition: all 0.3s;

  &:hover {
    background-color: #40a9ff;
  }

  &:disabled {
    background-color: #d9d9d9;
    cursor: not-allowed;
  }
`;
